import TrustpilotConfigurationService from '../module/ecocode-trustpilot/service/trustpilot-configuration.service';

Shopware.Application.addServiceProvider('ecocodeTrustpilotConfigurationService', container => {
    const initContainer = Shopware.Application.getContainer('init');
    return new TrustpilotConfigurationService(initContainer.httpClient, container.loginService, Shopware.Context.api);
});
